<div class="text-center">
  <img
    src="https://cdn.catexpert.ab-inbev.com/assets/images/{{ keyAccountPlaceholderObject.icon }}"
    alt="No Data Found"
    class="mx-auto w-[500px] mb-[-20px]"
  />
  <h2 class="head-h2 mb-2">
    {{ keyAccountPlaceholderObject.title | translate }}
  </h2>
  <p class="text-gray-600 mb-4">
    {{ keyAccountPlaceholderObject.description | translate }}
  </p>
</div>
